/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { createReducer, on } from '@ngrx/store';
import * as UserPreferencesActions from './user-preferences.actions';
import { initialState, IUserPreferencesState } from './user-preferences.state';

export const userPreferencesReducer = createReducer(
    initialState,
    on(
        UserPreferencesActions.fetchUserPreferences,
        (state: IUserPreferencesState): IUserPreferencesState => ({
            ...state,
            loaded: false,
            loading: true,
        }),
    ),
    on(
        UserPreferencesActions.fetchUserPreferencesSuccess,
        (state: IUserPreferencesState, { payload }): IUserPreferencesState => ({
            ...state,
            userPreferences: {
                ...payload,
            },
            loading: false,
            loaded: true,
        }),
    ),
    on(
        UserPreferencesActions.saveUserPreferencesSuccess,
        (state: IUserPreferencesState, { payload }): IUserPreferencesState => ({
            ...state,
            userPreferences: {
                ...payload,
            },
            loading: false,
        }),
    ),
    on(
        UserPreferencesActions.fetchUserPreferencesError,
        UserPreferencesActions.saveUserPreferencesError,
        (state: IUserPreferencesState): IUserPreferencesState => ({
            ...state,
            loading: false,
        }),
    ),
);
